import { StyledGridCol } from "@/common/styles";
import { useVocab } from "@/hooks/useVocab";
import { SummaryInfoGridRow, SummaryInfoItem } from "./styles";

// Light-theme key/value grid for the Booking and Warrant summary panels
// (see styles.js for why this exists instead of reusing FolderSearch's
// InformationContainer — that one's value text is hardcoded white, which
// is invisible on this Modal's white background).
// Keys are the labels shown, so they go through the site's Vocabulary renames.
const SummaryInfoGrid = ({ information }) => {
  const vocab = useVocab();
  return (
    <SummaryInfoGridRow gutter={[16, 8]}>
      {Object.entries(information?.basicInfo || {}).map(([key, value]) => (
        <StyledGridCol span={6} key={key}>
          <SummaryInfoItem>
            <span className="info-key">{vocab(key)}</span>
            <span className="info-value">{value || "—"}</span>
          </SummaryInfoItem>
        </StyledGridCol>
      ))}
      {Object.entries(information?.additionalInfo || {}).map(([key, value]) => (
        <StyledGridCol span={12} key={key}>
          <SummaryInfoItem>
            <span className="info-key">{vocab(key)}</span>
            <span className="info-value">{value || "—"}</span>
          </SummaryInfoItem>
        </StyledGridCol>
      ))}
    </SummaryInfoGridRow>
  );
};

export default SummaryInfoGrid;
